<template>
    <v-container>
      <v-row>
            <v-col cols="12">
              <div class="text-left" style="margin-bottom:20px;">
                  <router-link to="/archive">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                  </router-link>
                </div>                  
                <div class="text-left">
                    <p>January 30 Flights</p>
                </div>
                <div class="text-left">
                    <router-link to="/iceland/flights">
                        <v-btn
                            color="primary"
                            class="text-right"
                            style="width:500px"
                        >
                          Iceland
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <router-link to="/iceland/iceland31">
                        <v-btn
                            color="grey"
                            class="text-right"
                            style="width:500px"
                        >
                            January 31
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <router-link to="/iceland/iceland01">
                        <v-btn
                            color="grey"
                            class="text-right"
                            style="width:500px"
                        >
                            February 1
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row> 
        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <router-link to="/iceland/iceland02">
                        <v-btn
                            color="grey"
                            class="text-right"
                            style="width:500px"
                        >
                            February 2
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <router-link to="/iceland/iceland03">
                        <v-btn
                            color="grey"
                            class="text-right"
                            style="width:500px"
                        >
                            February 3
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <router-link to="/iceland/iceland04">
                        <v-btn
                            color="grey"
                            class="text-right"
                            style="width:500px"
                        >
                            February 4
                        </v-btn>
                    </router-link>
                </div>
            </v-col>
        </v-row>  
        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <p>Reykjavík to London 7:35am FI450 arrive London (LHW) at 10:50am</p>
                </div>
            </v-col>         
        </v-row>               
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>